
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as moreqepoOCoKxU5KUP84TkKPIwh8aOztAqxEzZ8VjLwNVvMMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/more.vue?macro=true";
import { default as pricing3ZmHEmEIbyZHstf7_45q4rkMlJPwD6uHvJEyptt_sPRKEMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/pricing.vue?macro=true";
import { default as dashboardPJm9vks5KFa3zN46j6YJyXsiruAJ_45NBITEI5OuwFqXIMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/dashboard.vue?macro=true";
import { default as login40g8TZaJHAH8tjo45tXwH6y1mcXRKXiFz7F8eWskq_0Meta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/login.vue?macro=true";
import { default as signupxZLnNecRdpkqbEbcbtPopewMDzAk_TJprtxvHfkNhYMMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/signup.vue?macro=true";
import { default as indexyrhmbWfA0uW2kCveMYDHElRc_45sD1jd7NApid5n1KcA0Meta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/groups/index.vue?macro=true";
import { default as completeMcYiEMZ1zVGGgyD2rL31LxVyj9lgQTZ_sknzlBub0sMMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/complete.vue?macro=true";
import { default as indexQNL8mkv1yhKPngac9_45_Gq_OKUUn5_K9EsyUJvRN2GNoMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/index.vue?macro=true";
import { default as about_45youF9tSWi54_45ztlKHYUq3aLobL2jgiHvYreNxhpIZ5DG_oMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/about-you.vue?macro=true";
import { default as indexMUf8pPRs5VwqrHHYXeWfoYWGhOgXYpN9H4pjW6m0cTcMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/webinars/index.vue?macro=true";
import { default as thank_45you2Gnmls41eSucHmdK2gvfYnUGGcsXWrToeOgU0mNrry0Meta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/enroll/thank-you.vue?macro=true";
import { default as verify_45emailxW0RDHw1_451ekAlvHJN7LprSwol86Y1xDUCuzlBSszVEMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/verify-email.vue?macro=true";
import { default as summaryWoLX0mCZVHQkNLLzR0yxbMJhGHZc_45dun5xie911B62YMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/summary.vue?macro=true";
import { default as comparison277imnOJ5Dw_45OnhNoDCfdWhbInQjlwXO5WLHpd2SedwMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/comparison.vue?macro=true";
import { default as recommendationse8taJUO4vcw0odSOmXNwzn0aqkOdfRNF7qsF4IBSP2cMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/recommendations.vue?macro=true";
import { default as _91quizId_935VPSENVa6GoHqPmR_I2DWzIUP_45zxRuXu9fKiLV9dBx8Meta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/quizzes/[quizId].vue?macro=true";
import { default as _91lessonId_93Hzdrsit0j_kulzNr082eGlnlnRO__45DCVyv_45kDTKjrQgMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/lessons/[lessonId].vue?macro=true";
import { default as _91courseId_93eBKr9qUwBJcrM_nFsg4AQ97QN7YBSzByhPnqJPnrgF4Meta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId].vue?macro=true";
import { default as _91planGroup_93c02gVtE_45rK6ewfRSKRsMwpISP5vLwaRQRVDO0S1iGV0Meta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/enroll/[planGroup].vue?macro=true";
import { default as _91webinar_93x7zSkXktWtD7PvtGQrpWFFRK3eQJGBNFJKGBZc_45s9XIMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/webinars/[webinar].vue?macro=true";
import { default as reset_45password_MqbB6eG2LsuqmesaSOCLkAqBpsivrhfAcdPlFkjRwMMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/reset-password.vue?macro=true";
import { default as profile_45infoBQTXjhR4h3xQ_452WRGuO6MJkSZmeqotCOKzhuL83Gir8Meta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/profile-info.vue?macro=true";
import { default as subscription8imaBKV4pKQSXU7j3_G2p7cUFnZ6ax0s6eg3VCGNyxIMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/subscription.vue?macro=true";
import { default as forgot_45passwordga7ebgZctw9xGTQXahURhrPLjUC9fcHBiG0w9kjTE_oMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/forgot-password.vue?macro=true";
import { default as welcome_45aboardwMJLJI4003NAhqkHZGX9ZL63ZYwdbSrSpZ6g_45sbJkhMMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/enroll/welcome-aboard.vue?macro=true";
import { default as app_45authenticatedRC48YDIRz3MK_hpvw4zw9YTnLTlHrSlv2B_innhe64YMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/app-authenticated.vue?macro=true";
import { default as _91planGroup_93rEBuOgID3FcfLPaNhzVJ7YgHS5olr_45A_FTiiP18JibcMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/enroll/new/[planGroup].vue?macro=true";
import { default as ai_45prompting_45toolTFLHh62fOgkWtVytOqbsZlpOzK1PTBoBSfntiKRzRQ8Meta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/tools/ai-prompting-tool.vue?macro=true";
import { default as professional_45info478SceMAiBuv2kY4GfO22OKnL8UWl5OLgGBnmPazCzsMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/professional-info.vue?macro=true";
import { default as _91memberId_93MskqKKi7Tg1ARrBYcR7kEEHhHDdw1Y3697o41J3sF90Meta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/groups/members/[memberId].vue?macro=true";
import { default as deletion_45cancelled1UbWgzS6Zcl4mbB4Cn1GJQXwETPoVJolB0zzjqirw1kMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/deletion-cancelled.vue?macro=true";
import { default as deletion_45scheduledsfEU9VEM09g7XGZbiZtGUGlNOqwIaOJJVblguQZ1xfwMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/deletion-scheduled.vue?macro=true";
import { default as confirm_45deletion_45codeDKJv86McJ0LtSddtJQ1ZzCvNI4u9WnTQeW5PSLSSPoMMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/confirm-deletion-code.vue?macro=true";
import { default as acceptbV_K9aCvJQ11c9ZuWbBryAiJaVJOXEnqzRWSkloAPmkMeta } from "/home/runner/work/learning-app-frontend/learning-app-frontend/pages/groups/[groupId]/invite/accept.vue?macro=true";
export default [
  {
    name: "more___en",
    path: "/more",
    meta: moreqepoOCoKxU5KUP84TkKPIwh8aOztAqxEzZ8VjLwNVvMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/more.vue")
  },
  {
    name: "more___de",
    path: "/de/more",
    meta: moreqepoOCoKxU5KUP84TkKPIwh8aOztAqxEzZ8VjLwNVvMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/more.vue")
  },
  {
    name: "more___fr",
    path: "/fr/more",
    meta: moreqepoOCoKxU5KUP84TkKPIwh8aOztAqxEzZ8VjLwNVvMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/more.vue")
  },
  {
    name: "more___es",
    path: "/es/more",
    meta: moreqepoOCoKxU5KUP84TkKPIwh8aOztAqxEzZ8VjLwNVvMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/more.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    meta: pricing3ZmHEmEIbyZHstf7_45q4rkMlJPwD6uHvJEyptt_sPRKEMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/pricing.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardPJm9vks5KFa3zN46j6YJyXsiruAJ_45NBITEI5OuwFqXIMeta || {},
    alias: ["/"],
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/dashboard.vue")
  },
  {
    name: "auth-login___en",
    path: "/auth/login",
    meta: login40g8TZaJHAH8tjo45tXwH6y1mcXRKXiFz7F8eWskq_0Meta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/login.vue")
  },
  {
    name: "auth-login___de",
    path: "/de/auth/login",
    meta: login40g8TZaJHAH8tjo45tXwH6y1mcXRKXiFz7F8eWskq_0Meta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/login.vue")
  },
  {
    name: "auth-login___fr",
    path: "/fr/auth/login",
    meta: login40g8TZaJHAH8tjo45tXwH6y1mcXRKXiFz7F8eWskq_0Meta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/login.vue")
  },
  {
    name: "auth-login___es",
    path: "/es/auth/login",
    meta: login40g8TZaJHAH8tjo45tXwH6y1mcXRKXiFz7F8eWskq_0Meta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/login.vue")
  },
  {
    name: "auth-signup___en",
    path: "/auth/signup",
    meta: signupxZLnNecRdpkqbEbcbtPopewMDzAk_TJprtxvHfkNhYMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/signup.vue")
  },
  {
    name: "auth-signup___de",
    path: "/de/auth/signup",
    meta: signupxZLnNecRdpkqbEbcbtPopewMDzAk_TJprtxvHfkNhYMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/signup.vue")
  },
  {
    name: "auth-signup___fr",
    path: "/fr/auth/signup",
    meta: signupxZLnNecRdpkqbEbcbtPopewMDzAk_TJprtxvHfkNhYMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/signup.vue")
  },
  {
    name: "auth-signup___es",
    path: "/es/auth/signup",
    meta: signupxZLnNecRdpkqbEbcbtPopewMDzAk_TJprtxvHfkNhYMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/signup.vue")
  },
  {
    name: "groups___en",
    path: "/groups",
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/groups/index.vue")
  },
  {
    name: "groups___de",
    path: "/de/groups",
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/groups/index.vue")
  },
  {
    name: "groups___fr",
    path: "/fr/groups",
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/groups/index.vue")
  },
  {
    name: "groups___es",
    path: "/es/groups",
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/groups/index.vue")
  },
  {
    name: "auth-complete___en",
    path: "/auth/complete",
    meta: completeMcYiEMZ1zVGGgyD2rL31LxVyj9lgQTZ_sknzlBub0sMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/complete.vue")
  },
  {
    name: "auth-complete___de",
    path: "/de/auth/complete",
    meta: completeMcYiEMZ1zVGGgyD2rL31LxVyj9lgQTZ_sknzlBub0sMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/complete.vue")
  },
  {
    name: "auth-complete___fr",
    path: "/fr/auth/complete",
    meta: completeMcYiEMZ1zVGGgyD2rL31LxVyj9lgQTZ_sknzlBub0sMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/complete.vue")
  },
  {
    name: "auth-complete___es",
    path: "/es/auth/complete",
    meta: completeMcYiEMZ1zVGGgyD2rL31LxVyj9lgQTZ_sknzlBub0sMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/complete.vue")
  },
  {
    name: "courses",
    path: "/courses",
    meta: indexQNL8mkv1yhKPngac9_45_Gq_OKUUn5_K9EsyUJvRN2GNoMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/index.vue")
  },
  {
    name: "auth-about-you",
    path: "/auth/about-you",
    meta: about_45youF9tSWi54_45ztlKHYUq3aLobL2jgiHvYreNxhpIZ5DG_oMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/about-you.vue")
  },
  {
    name: "webinars",
    path: "/webinars",
    meta: indexMUf8pPRs5VwqrHHYXeWfoYWGhOgXYpN9H4pjW6m0cTcMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/webinars/index.vue")
  },
  {
    name: "thank-you",
    path: "/enroll/thank-you",
    meta: thank_45you2Gnmls41eSucHmdK2gvfYnUGGcsXWrToeOgU0mNrry0Meta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/enroll/thank-you.vue")
  },
  {
    name: "auth-verify-email___en",
    path: "/auth/verify-email",
    meta: verify_45emailxW0RDHw1_451ekAlvHJN7LprSwol86Y1xDUCuzlBSszVEMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/verify-email.vue")
  },
  {
    name: "auth-verify-email___de",
    path: "/de/auth/verify-email",
    meta: verify_45emailxW0RDHw1_451ekAlvHJN7LprSwol86Y1xDUCuzlBSszVEMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/verify-email.vue")
  },
  {
    name: "auth-verify-email___fr",
    path: "/fr/auth/verify-email",
    meta: verify_45emailxW0RDHw1_451ekAlvHJN7LprSwol86Y1xDUCuzlBSszVEMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/verify-email.vue")
  },
  {
    name: "auth-verify-email___es",
    path: "/es/auth/verify-email",
    meta: verify_45emailxW0RDHw1_451ekAlvHJN7LprSwol86Y1xDUCuzlBSszVEMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/verify-email.vue")
  },
  {
    name: "course___en",
    path: "/courses/:courseId()",
    meta: { ...(_91courseId_93eBKr9qUwBJcrM_nFsg4AQ97QN7YBSzByhPnqJPnrgF4Meta || {}), ...{"middleware":"course-middleware"} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId].vue"),
    children: [
  {
    name: "summary___en",
    path: "summary",
    meta: { ...(summaryWoLX0mCZVHQkNLLzR0yxbMJhGHZc_45dun5xie911B62YMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/summary.vue")
  },
  {
    name: "comparison___en",
    path: "comparison",
    meta: { ...(comparison277imnOJ5Dw_45OnhNoDCfdWhbInQjlwXO5WLHpd2SedwMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/comparison.vue")
  },
  {
    name: "recommendations___en",
    path: "recommendations",
    meta: { ...(recommendationse8taJUO4vcw0odSOmXNwzn0aqkOdfRNF7qsF4IBSP2cMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/recommendations.vue")
  },
  {
    name: "quiz___en",
    path: "quizzes/:quizId()",
    meta: { ...(_91quizId_935VPSENVa6GoHqPmR_I2DWzIUP_45zxRuXu9fKiLV9dBx8Meta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/quizzes/[quizId].vue")
  },
  {
    name: "lesson___en",
    path: "lessons/:lessonId()",
    meta: { ...(_91lessonId_93Hzdrsit0j_kulzNr082eGlnlnRO__45DCVyv_45kDTKjrQgMeta || {}), ...{"middleware":["course-activity-access-middleware"]} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/lessons/[lessonId].vue")
  }
]
  },
  {
    name: "course___de",
    path: "/de/courses/:courseId()",
    meta: { ...(_91courseId_93eBKr9qUwBJcrM_nFsg4AQ97QN7YBSzByhPnqJPnrgF4Meta || {}), ...{"middleware":"course-middleware"} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId].vue"),
    children: [
  {
    name: "summary___de",
    path: "summary",
    meta: { ...(summaryWoLX0mCZVHQkNLLzR0yxbMJhGHZc_45dun5xie911B62YMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/summary.vue")
  },
  {
    name: "comparison___de",
    path: "comparison",
    meta: { ...(comparison277imnOJ5Dw_45OnhNoDCfdWhbInQjlwXO5WLHpd2SedwMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/comparison.vue")
  },
  {
    name: "recommendations___de",
    path: "recommendations",
    meta: { ...(recommendationse8taJUO4vcw0odSOmXNwzn0aqkOdfRNF7qsF4IBSP2cMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/recommendations.vue")
  },
  {
    name: "quiz___de",
    path: "quizzes/:quizId()",
    meta: { ...(_91quizId_935VPSENVa6GoHqPmR_I2DWzIUP_45zxRuXu9fKiLV9dBx8Meta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/quizzes/[quizId].vue")
  },
  {
    name: "lesson___de",
    path: "lessons/:lessonId()",
    meta: { ...(_91lessonId_93Hzdrsit0j_kulzNr082eGlnlnRO__45DCVyv_45kDTKjrQgMeta || {}), ...{"middleware":["course-activity-access-middleware"]} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/lessons/[lessonId].vue")
  }
]
  },
  {
    name: "course___fr",
    path: "/fr/courses/:courseId()",
    meta: { ...(_91courseId_93eBKr9qUwBJcrM_nFsg4AQ97QN7YBSzByhPnqJPnrgF4Meta || {}), ...{"middleware":"course-middleware"} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId].vue"),
    children: [
  {
    name: "summary___fr",
    path: "summary",
    meta: { ...(summaryWoLX0mCZVHQkNLLzR0yxbMJhGHZc_45dun5xie911B62YMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/summary.vue")
  },
  {
    name: "comparison___fr",
    path: "comparison",
    meta: { ...(comparison277imnOJ5Dw_45OnhNoDCfdWhbInQjlwXO5WLHpd2SedwMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/comparison.vue")
  },
  {
    name: "recommendations___fr",
    path: "recommendations",
    meta: { ...(recommendationse8taJUO4vcw0odSOmXNwzn0aqkOdfRNF7qsF4IBSP2cMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/recommendations.vue")
  },
  {
    name: "quiz___fr",
    path: "quizzes/:quizId()",
    meta: { ...(_91quizId_935VPSENVa6GoHqPmR_I2DWzIUP_45zxRuXu9fKiLV9dBx8Meta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/quizzes/[quizId].vue")
  },
  {
    name: "lesson___fr",
    path: "lessons/:lessonId()",
    meta: { ...(_91lessonId_93Hzdrsit0j_kulzNr082eGlnlnRO__45DCVyv_45kDTKjrQgMeta || {}), ...{"middleware":["course-activity-access-middleware"]} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/lessons/[lessonId].vue")
  }
]
  },
  {
    name: "course___es",
    path: "/es/courses/:courseId()",
    meta: { ...(_91courseId_93eBKr9qUwBJcrM_nFsg4AQ97QN7YBSzByhPnqJPnrgF4Meta || {}), ...{"middleware":"course-middleware"} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId].vue"),
    children: [
  {
    name: "summary___es",
    path: "summary",
    meta: { ...(summaryWoLX0mCZVHQkNLLzR0yxbMJhGHZc_45dun5xie911B62YMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/summary.vue")
  },
  {
    name: "comparison___es",
    path: "comparison",
    meta: { ...(comparison277imnOJ5Dw_45OnhNoDCfdWhbInQjlwXO5WLHpd2SedwMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/comparison.vue")
  },
  {
    name: "recommendations___es",
    path: "recommendations",
    meta: { ...(recommendationse8taJUO4vcw0odSOmXNwzn0aqkOdfRNF7qsF4IBSP2cMeta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/recommendations.vue")
  },
  {
    name: "quiz___es",
    path: "quizzes/:quizId()",
    meta: { ...(_91quizId_935VPSENVa6GoHqPmR_I2DWzIUP_45zxRuXu9fKiLV9dBx8Meta || {}), ...{"middleware":"course-activity-access-middleware"} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/quizzes/[quizId].vue")
  },
  {
    name: "lesson___es",
    path: "lessons/:lessonId()",
    meta: { ...(_91lessonId_93Hzdrsit0j_kulzNr082eGlnlnRO__45DCVyv_45kDTKjrQgMeta || {}), ...{"middleware":["course-activity-access-middleware"]} },
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/courses/[courseId]/lessons/[lessonId].vue")
  }
]
  },
  {
    name: "enroll",
    path: "/enroll/:planGroup()",
    meta: _91planGroup_93c02gVtE_45rK6ewfRSKRsMwpISP5vLwaRQRVDO0S1iGV0Meta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/enroll/[planGroup].vue")
  },
  {
    name: "webinars-webinar",
    path: "/webinars/:webinar()",
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/webinars/[webinar].vue")
  },
  {
    name: "auth-reset-password___en",
    path: "/auth/reset-password",
    meta: reset_45password_MqbB6eG2LsuqmesaSOCLkAqBpsivrhfAcdPlFkjRwMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___de",
    path: "/de/auth/reset-password",
    meta: reset_45password_MqbB6eG2LsuqmesaSOCLkAqBpsivrhfAcdPlFkjRwMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___fr",
    path: "/fr/auth/reset-password",
    meta: reset_45password_MqbB6eG2LsuqmesaSOCLkAqBpsivrhfAcdPlFkjRwMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___es",
    path: "/es/auth/reset-password",
    meta: reset_45password_MqbB6eG2LsuqmesaSOCLkAqBpsivrhfAcdPlFkjRwMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/reset-password.vue")
  },
  {
    name: "account-profile-info",
    path: "/account/profile-info",
    meta: profile_45infoBQTXjhR4h3xQ_452WRGuO6MJkSZmeqotCOKzhuL83Gir8Meta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/profile-info.vue")
  },
  {
    name: "account-subscription",
    path: "/account/subscription",
    meta: subscription8imaBKV4pKQSXU7j3_G2p7cUFnZ6ax0s6eg3VCGNyxIMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/subscription.vue")
  },
  {
    name: "auth-forgot-password___en",
    path: "/auth/forgot-password",
    meta: forgot_45passwordga7ebgZctw9xGTQXahURhrPLjUC9fcHBiG0w9kjTE_oMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-forgot-password___de",
    path: "/de/auth/forgot-password",
    meta: forgot_45passwordga7ebgZctw9xGTQXahURhrPLjUC9fcHBiG0w9kjTE_oMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-forgot-password___fr",
    path: "/fr/auth/forgot-password",
    meta: forgot_45passwordga7ebgZctw9xGTQXahURhrPLjUC9fcHBiG0w9kjTE_oMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-forgot-password___es",
    path: "/es/auth/forgot-password",
    meta: forgot_45passwordga7ebgZctw9xGTQXahURhrPLjUC9fcHBiG0w9kjTE_oMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/forgot-password.vue")
  },
  {
    name: "welcome-aboard___en",
    path: "/enroll/welcome-aboard",
    meta: welcome_45aboardwMJLJI4003NAhqkHZGX9ZL63ZYwdbSrSpZ6g_45sbJkhMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/enroll/welcome-aboard.vue")
  },
  {
    name: "welcome-aboard___de",
    path: "/de/enroll/welcome-aboard",
    meta: welcome_45aboardwMJLJI4003NAhqkHZGX9ZL63ZYwdbSrSpZ6g_45sbJkhMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/enroll/welcome-aboard.vue")
  },
  {
    name: "welcome-aboard___fr",
    path: "/fr/enroll/welcome-aboard",
    meta: welcome_45aboardwMJLJI4003NAhqkHZGX9ZL63ZYwdbSrSpZ6g_45sbJkhMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/enroll/welcome-aboard.vue")
  },
  {
    name: "welcome-aboard___es",
    path: "/es/enroll/welcome-aboard",
    meta: welcome_45aboardwMJLJI4003NAhqkHZGX9ZL63ZYwdbSrSpZ6g_45sbJkhMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/enroll/welcome-aboard.vue")
  },
  {
    name: "auth-app-authenticated___en",
    path: "/auth/app-authenticated",
    meta: app_45authenticatedRC48YDIRz3MK_hpvw4zw9YTnLTlHrSlv2B_innhe64YMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/app-authenticated.vue")
  },
  {
    name: "auth-app-authenticated___de",
    path: "/de/auth/app-authenticated",
    meta: app_45authenticatedRC48YDIRz3MK_hpvw4zw9YTnLTlHrSlv2B_innhe64YMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/app-authenticated.vue")
  },
  {
    name: "auth-app-authenticated___fr",
    path: "/fr/auth/app-authenticated",
    meta: app_45authenticatedRC48YDIRz3MK_hpvw4zw9YTnLTlHrSlv2B_innhe64YMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/app-authenticated.vue")
  },
  {
    name: "auth-app-authenticated___es",
    path: "/es/auth/app-authenticated",
    meta: app_45authenticatedRC48YDIRz3MK_hpvw4zw9YTnLTlHrSlv2B_innhe64YMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/auth/app-authenticated.vue")
  },
  {
    name: "enroll-new",
    path: "/enroll/new/:planGroup()",
    meta: _91planGroup_93rEBuOgID3FcfLPaNhzVJ7YgHS5olr_45A_FTiiP18JibcMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/enroll/new/[planGroup].vue")
  },
  {
    name: "tools-ai-prompting-tool",
    path: "/tools/ai-prompting-tool",
    meta: ai_45prompting_45toolTFLHh62fOgkWtVytOqbsZlpOzK1PTBoBSfntiKRzRQ8Meta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/tools/ai-prompting-tool.vue")
  },
  {
    name: "account-professional-info",
    path: "/account/professional-info",
    meta: professional_45info478SceMAiBuv2kY4GfO22OKnL8UWl5OLgGBnmPazCzsMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/professional-info.vue")
  },
  {
    name: "groups-members-memberId___en",
    path: "/groups/members/:memberId()",
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/groups/members/[memberId].vue")
  },
  {
    name: "groups-members-memberId___de",
    path: "/de/groups/members/:memberId()",
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/groups/members/[memberId].vue")
  },
  {
    name: "groups-members-memberId___fr",
    path: "/fr/groups/members/:memberId()",
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/groups/members/[memberId].vue")
  },
  {
    name: "groups-members-memberId___es",
    path: "/es/groups/members/:memberId()",
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/groups/members/[memberId].vue")
  },
  {
    name: "account-deletion-cancelled___en",
    path: "/account/deletion-cancelled",
    meta: deletion_45cancelled1UbWgzS6Zcl4mbB4Cn1GJQXwETPoVJolB0zzjqirw1kMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/deletion-cancelled.vue")
  },
  {
    name: "account-deletion-cancelled___de",
    path: "/de/account/deletion-cancelled",
    meta: deletion_45cancelled1UbWgzS6Zcl4mbB4Cn1GJQXwETPoVJolB0zzjqirw1kMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/deletion-cancelled.vue")
  },
  {
    name: "account-deletion-cancelled___fr",
    path: "/fr/account/deletion-cancelled",
    meta: deletion_45cancelled1UbWgzS6Zcl4mbB4Cn1GJQXwETPoVJolB0zzjqirw1kMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/deletion-cancelled.vue")
  },
  {
    name: "account-deletion-cancelled___es",
    path: "/es/account/deletion-cancelled",
    meta: deletion_45cancelled1UbWgzS6Zcl4mbB4Cn1GJQXwETPoVJolB0zzjqirw1kMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/deletion-cancelled.vue")
  },
  {
    name: "account-deletion-scheduled___en",
    path: "/account/deletion-scheduled",
    meta: deletion_45scheduledsfEU9VEM09g7XGZbiZtGUGlNOqwIaOJJVblguQZ1xfwMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/deletion-scheduled.vue")
  },
  {
    name: "account-deletion-scheduled___de",
    path: "/de/account/deletion-scheduled",
    meta: deletion_45scheduledsfEU9VEM09g7XGZbiZtGUGlNOqwIaOJJVblguQZ1xfwMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/deletion-scheduled.vue")
  },
  {
    name: "account-deletion-scheduled___fr",
    path: "/fr/account/deletion-scheduled",
    meta: deletion_45scheduledsfEU9VEM09g7XGZbiZtGUGlNOqwIaOJJVblguQZ1xfwMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/deletion-scheduled.vue")
  },
  {
    name: "account-deletion-scheduled___es",
    path: "/es/account/deletion-scheduled",
    meta: deletion_45scheduledsfEU9VEM09g7XGZbiZtGUGlNOqwIaOJJVblguQZ1xfwMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/deletion-scheduled.vue")
  },
  {
    name: "account-confirm-deletion-code___en",
    path: "/account/confirm-deletion-code",
    meta: confirm_45deletion_45codeDKJv86McJ0LtSddtJQ1ZzCvNI4u9WnTQeW5PSLSSPoMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/confirm-deletion-code.vue")
  },
  {
    name: "account-confirm-deletion-code___de",
    path: "/de/account/confirm-deletion-code",
    meta: confirm_45deletion_45codeDKJv86McJ0LtSddtJQ1ZzCvNI4u9WnTQeW5PSLSSPoMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/confirm-deletion-code.vue")
  },
  {
    name: "account-confirm-deletion-code___fr",
    path: "/fr/account/confirm-deletion-code",
    meta: confirm_45deletion_45codeDKJv86McJ0LtSddtJQ1ZzCvNI4u9WnTQeW5PSLSSPoMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/confirm-deletion-code.vue")
  },
  {
    name: "account-confirm-deletion-code___es",
    path: "/es/account/confirm-deletion-code",
    meta: confirm_45deletion_45codeDKJv86McJ0LtSddtJQ1ZzCvNI4u9WnTQeW5PSLSSPoMMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/account/confirm-deletion-code.vue")
  },
  {
    name: "groups-groupId-invite-accept",
    path: "/groups/:groupId()/invite/accept",
    meta: acceptbV_K9aCvJQ11c9ZuWbBryAiJaVJOXEnqzRWSkloAPmkMeta || {},
    component: () => import("/home/runner/work/learning-app-frontend/learning-app-frontend/pages/groups/[groupId]/invite/accept.vue")
  }
]